import { render, staticRenderFns } from "./CmgRecipesBanner.vue?vue&type=template&id=003c4525&scoped=true&lang=pug&"
import script from "./cmg-recipes-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-recipes-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRecipesBanner.vue?vue&type=style&index=0&id=003c4525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c4525",
  null
  
)

export default component.exports